import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { FuseSharedModule } from '@fuse/shared.module';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { epwComponent } from '../EPW/epw.component';
import { MaterialModule } from './material.module';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpService } from '../../../services/http.service';
import { Login2Component } from '../login-2/login-2.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { AbortJobDialog } from '../EPW/abort_job/abort_job.component';
import { SecondaryFreightComponent } from './secondary-freight/secondary-freight.component';

const routes = [
    {
        path     : 'epw/detail',
        component: epwComponent
    },
    {
        path     : 'epw/detail/:jobId',
        component: epwComponent
    },
    {
        path     : 'epw',
        component: Login2Component
    },
    // {
    //     path     : ':id',
    //     component: AbortJobDialog
    // },
    {
        path     : '',
        component: Login2Component
    },

    //replaced below path with bulk
    // {  
    //     path     : 'secondaryfreight/login',
    //     component: SecondaryFreightComponent
    // },
];

@NgModule({
    declarations: [
        epwComponent,

    ],
    imports     : [
        RouterModule.forChild(routes),
        Ng2ImgMaxModule,
        MatButtonModule,
        
        SignaturePadModule,
        FormsModule,
        NgxSpinnerModule,
        MatCheckboxModule,
        MatFormFieldModule, 
        MatInputModule,
        MaterialModule,
        FuseSharedModule
    ],
    providers: [AbortJobDialog,HttpService,
        {provide: MatDialogRef, useValue: {}},
        { provide: MAT_DIALOG_DATA, useValue: [] },]
       
})
export class epwModule
{
}
